// ----------------------------------------------------------------------
// <copyright file="Izenda.EventUtils.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  const { get, isFunction } = require('lodash/fp');
  module.exports = {
    INPUT: 'target.value',
    DROPDOWN: 'value',
    CHECKBOX: 'target.checked',
    RADIO: 'target.checked',
    INPUT_BY_TYPE: 'value',

    notifyChange: function(func, paramPath) {
      return function(arg1, arg2) {
        var value = paramPath ? get(paramPath, arg1) : arg1;
        return isFunction(func) && func(value, arg2);
      };
    },

    notify: function(func) {
      return function() {
        return isFunction(func) && func();
      };
    }
  };
})();



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.EventUtils.js